import { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useMap } from 'react-map-gl'

export default function MapZoomIndicator() {
  const { current } = useMap()
  const [zoom, setZoom] = useState<string>()

  useEffect(() => {
    if (!current) return
    const update = () => {
      // Don't report a layer's minimum zoom as reached just before it is visible.
      setZoom((Math.floor(current.getZoom() * 10) / 10).toFixed(1))
    }
    update()
    current.on('zoom', update)
    return () => {
      current.off('zoom', update)
    }
  }, [current])

  if (zoom == null) return null
  return (
    <Typography
      component="span"
      variant="caption"
      title="Current map zoom level"
      sx={{
        px: 1,
        py: 0.5,
        borderRadius: 1,
        bgcolor: 'rgba(255, 255, 255, 0.9)',
        color: 'text.secondary',
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      Zoom{' '}
      <Box component="span" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
        {zoom}
      </Box>
    </Typography>
  )
}
